import React, {useMemo} from 'react'
import {useSelector} from 'react-redux'
import {
  DatelessCTA,
  DatelessCTAVariant
} from 'components/Accommodation/Offers/DatelessCTA/DatelessCTA'
import {getUserCountryCode} from 'modules/meta/selectors'

import {Box} from '@vio/atlas/helpers/Box'
import {useDeviceLayout} from '@vio/atlas/src/context/deviceLayout'
import {sortTopRoomImagesByCaption} from '@vio/core/src/room/business/utils/sortRoomImages'

import {FrozenRoomOffer} from '../../FrozenRoomOffer/FrozenRoomOffer'
import {RoomOffersList} from '../../RoomOffersList'
import {RoomCardInfo} from '../RoomCardInfo'
import {RoomGalleryTiles} from '../RoomGalleryTiles'
import {RoomCardLayoutProps} from '../types'

export const RoomCardMobile = ({
  room,
  onOpenRoomDetailsOverlay,
  isDetailsLinkVisible,
  roomsSplit,
  isFrozen,
  isDateless
}: RoomCardLayoutProps) => {
  const userCountry = useSelector(getUserCountryCode)
  const {isDesktopXs} = useDeviceLayout()

  const sortedImages = useMemo(
    () => sortTopRoomImagesByCaption(room.images),
    [room.images]
  )

  const renderRoomOffer = () => {
    if (isDateless)
      return (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="flex-end"
          alignItems="flex-end"
        >
          <Box
            height="100%"
            minWidth={isDesktopXs ? '256px' : '100%'}
            paddingTop="s400"
            paddingLeft={isDesktopXs ? 's500' : 's400'}
            paddingRight={isDesktopXs ? 's500' : 's400'}
            paddingBottom="s200"
          >
            <DatelessCTA variant={DatelessCTAVariant.RoomListing} />
          </Box>
        </Box>
      )

    return isFrozen ? (
      <Box
        paddingLeft={isDesktopXs ? 's500' : 's400'}
        paddingRight={isDesktopXs ? 's500' : 's400'}
      >
        <FrozenRoomOffer room={room} />
      </Box>
    ) : (
      <Box
        paddingLeft={isDesktopXs ? 's500' : 's000'}
        paddingRight={isDesktopXs ? 's500' : 's000'}
      >
        <RoomOffersList room={room} />
      </Box>
    )
  }

  return (
    <Box paddingBottom="s400">
      <RoomGalleryTiles
        images={sortedImages}
        onClick={onOpenRoomDetailsOverlay}
      />
      <Box width="100%" padding={isDesktopXs ? 's500' : 's400'}>
        <RoomCardInfo
          room={room}
          userCountry={userCountry}
          roomsSplit={roomsSplit}
          onOpenRoomDetailsOverlay={onOpenRoomDetailsOverlay}
          isDetailsLinkVisible={isDetailsLinkVisible}
        />
      </Box>

      {renderRoomOffer()}
    </Box>
  )
}
